var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.user)?_c('div',[_vm._v("Erfolgreich authentifiziert")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }